/**
 * @generated SignedSource<<90e11eee58d7020f9ed944d7e0dac72a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailTemplateViewQuery$variables = {
  id: string;
};
export type EmailTemplateViewQuery$data = {
  readonly emailLayouts: ReadonlyArray<{
    readonly emailLayoutIdentifier: string;
    readonly htmlContent: string;
    readonly id: string;
    readonly isDefault: boolean;
    readonly name: string;
  }>;
  readonly emailTemplate: {
    readonly id: string;
    readonly name: string;
    readonly usageCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EmailTemplateDetailsView_emailTemplate">;
  } | null | undefined;
};
export type EmailTemplateViewQuery = {
  response: EmailTemplateViewQuery$data;
  variables: EmailTemplateViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usageCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailLayoutIdentifier",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "htmlContent",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "EmailLayout",
  "kind": "LinkedField",
  "name": "emailLayouts",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textContent",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplateViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmailTemplate",
        "kind": "LinkedField",
        "name": "emailTemplate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmailTemplateDetailsView_emailTemplate"
          }
        ],
        "storageKey": null
      },
      (v7/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailTemplateViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmailTemplate",
        "kind": "LinkedField",
        "name": "emailTemplate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailTemplateIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryLanguage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailTemplateVariant",
            "kind": "LinkedField",
            "name": "variants",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preheader",
                "storageKey": null
              },
              (v6/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailLayout",
            "kind": "LinkedField",
            "name": "emailLayout",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v3/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailTemplateImage",
            "kind": "LinkedField",
            "name": "images",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailTemplateImageIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "originalFilename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediaType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileSize",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v7/*: any*/)
    ]
  },
  "params": {
    "cacheID": "4a09287ed2cbe703a0e0f7c6795be6bb",
    "id": null,
    "metadata": {},
    "name": "EmailTemplateViewQuery",
    "operationKind": "query",
    "text": "query EmailTemplateViewQuery(\n  $id: ID!\n) {\n  emailTemplate(id: $id) {\n    id\n    name\n    usageCount\n    ...EmailTemplateDetailsView_emailTemplate\n  }\n  emailLayouts {\n    id\n    emailLayoutIdentifier\n    name\n    isDefault\n    htmlContent\n  }\n}\n\nfragment DeleteEmailTemplateDialog_emailTemplate on EmailTemplate {\n  id\n  name\n}\n\nfragment EmailTemplateDetailsView_emailTemplate on EmailTemplate {\n  id\n  emailTemplateIdentifier\n  primaryLanguage\n  variants {\n    language\n    subject\n    preheader\n    htmlContent\n    textContent\n  }\n  emailLayout {\n    id\n    emailLayoutIdentifier\n    name\n    textContent\n  }\n  images {\n    id\n    emailTemplateImageIdentifier\n    url\n    originalFilename\n    width\n    height\n    mediaType\n    fileSize\n  }\n  usageCount\n  ...DeleteEmailTemplateDialog_emailTemplate\n}\n"
  }
};
})();

(node as any).hash = "1fcbc00defecebd6f2e61e5630954295";

export default node;
